import React from "react";
import CodeBlocks from "../Components/core/HomePage/CodeBlocks";
import ExploreMore from "../Components/core/HomePage/ExploreMore";
import TimelineSection from "../Components/core/HomePage/TimelineSection";
import LearningLanguageSection from "../Components/core/HomePage/LearningLanguageSection";
import InstructorSection from "../Components/core/HomePage/InstructorSection";
import HighlightText from "../Components/core/HomePage/HighlightText";

const CODE_SNIPPET_1 = `import React from "react";
import CTAButton from "./Button";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div>Home</div>
  );
};

export default Home;`;

const CODE_SNIPPET_2 = `import React from "react";
import { useState } from "react";

const Example = () => {
  const [count, setCount] = useState(0);
  return (
    <button onClick={() => setCount(count + 1)}>
      Count: {count}
    </button>
  );
};

export default Example;`;

function Home() {
  return (
    <div className="font-inter text-richblack-5">
      <div className="w-full bg-richblack-900">
        <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col gap-6 pb-16 pt-10 md:pt-14">
          <CodeBlocks
            position="lg:flex-row"
            heading={
              <div className="text-4xl font-semibold text-richblack-5 lg:w-[45%]">
                Unlock your <HighlightText variant="hero" text={"coding potential"} /> with our
                online courses
              </div>
            }
            subheading="With our online courses, you can learn at your own pace, from anywhere in the world, and get access to a wealth of resources, including hands-on projects, quizzes, and personalized feedback from instructors."
            ctabtn1={{
              btnText: "Learn More",
              linkto: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Book a Demo",
              linkto: "/login",
              active: false,
            }}
            codeblock={CODE_SNIPPET_1}
            codeColor="text-richblack-5"
            backgroudGradient="grad"
          />

          <CodeBlocks
            position="lg:flex-row-reverse"
            heading={
              <div className="text-4xl font-semibold text-richblack-5 lg:w-[45%]">
                Start <HighlightText variant="hero" text={"coding in seconds"} />
              </div>
            }
            subheading="Go ahead, give it a try. Our hands-on learning environment means you will be writing real code from your very first lesson."
            ctabtn1={{
              btnText: "Continue Lesson",
              linkto: "/signup",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              linkto: "/login",
              active: false,
            }}
            codeblock={CODE_SNIPPET_2}
            codeColor="text-richblack-5"
            backgroudGradient="grad"
          />
        </div>
      </div>

      <div className="w-full bg-richblack-900 pb-20 pt-8">
        <div className="relative mx-auto w-11/12 max-w-maxContent">
          <ExploreMore />
        </div>
      </div>

      <div className="w-full bg-richblack-5 py-20 text-richblack-900">
        <div className="mx-auto w-11/12 max-w-maxContent">
          <TimelineSection />
        </div>
      </div>

      <div className="w-full bg-richblack-5 py-8 text-richblack-900">
        <div className="mx-auto w-11/12 max-w-maxContent">
          <LearningLanguageSection />
        </div>
      </div>

      <div className="w-full bg-richblack-900 py-20 text-richblack-5">
        <div className="mx-auto w-11/12 max-w-maxContent">
          <InstructorSection />
        </div>
      </div>
    </div>
  );
}

export default Home;
